import prop from 'ramda/src/prop'
import curry from 'ramda/src/curry'
import pipe from 'ramda/src/pipe'

import creatorDataSelector from 'root/src/client/logic/creatorData/selectors/creatorDataSelector'

export default curry((propName, state) => pipe(creatorDataSelector, prop(propName))(state))
